'use strict';

exports.roles = ['On-site Contact', 'Lead Organizer', 'Accounting Contact', 'Budget Approver'];